import { createFileRoute } from "@tanstack/react-router";
import { ReportsPage } from "@/app/connect/pages/reports";

type ReportsSearchParams = {
	provider_id?: string;
};

function cleanId(value: unknown): string | undefined {
	if (typeof value === "number") return String(value);
	if (typeof value === "string") {
		const cleaned = value.replace(/^["']|["']$/g, "");
		return cleaned || undefined;
	}
	return undefined;
}

export const Route = createFileRoute("/connect/reports")({
	validateSearch: (search: Record<string, unknown>): ReportsSearchParams => ({
		provider_id: cleanId(search.provider_id),
	}),
	component: ReportsPage,
});
